import React, { useState } from "react";
import AnimatedSection from "../components/AnimatedSection";
import { FaWhatsapp } from "react-icons/fa";

const ContactUs = () => {
  const [form, setForm] = useState({
    name: "",
    company: "",
    subject: "Request for Quote (RFQ)",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const phoneNumber = "94772516056";

    const text = `Hello 👋,
I’m interested in your services.

Name: ${form.name}
Company: ${form.company}
Subject: ${form.subject}

Message:
${form.message}`;

    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <div className="relative flex flex-col min-h-screen w-full overflow-x-hidden font-inter text-gray-800">
      {/* HERO */}
      <section className="bg-gradient-hero text-primary-foreground py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AnimatedSection>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">
              Contact Us
            </h1>
            <p className="mt-3 sm:mt-4 text-base sm:text-lg opacity-80 max-w-xl">
              Let's discuss your next project. Our team is ready to help.
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* MAIN */}
      <main className="flex-1 py-12 sm:py-16 bg-slate-100">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-10">
          {/* TOP GRID */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 sm:gap-16">
            {/* LEFT → CONTACT INFO */}
            <AnimatedSection>
              <section className="space-y-10">
                <h2 className="text-gray-900 text-2xl sm:text-3xl font-bold">
                  Contact Information
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
                  {/* Phone 1 */}
                  <div className="bg-white p-5 rounded-xl shadow hover:shadow-lg transition">
                    <p className="text-xs text-gray-500 font-bold uppercase">
                      Phone 01
                    </p>
                    <a
                      href="tel:+94772516056"
                      className="text-lg font-semibold hover:text-green-700"
                    >
                      +94 77 251 6056
                    </a>
                    <a
                      href="https://wa.me/94772516056"
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center gap-2 text-green-600 text-sm mt-1"
                    >
                      <FaWhatsapp className="text-lg" />
                      WhatsApp
                    </a>
                    <p className="text-sm text-gray-600 mt-1">
                      Industrial Sales
                    </p>
                  </div>

                  {/* Phone 2 */}
                  <div className="bg-white p-5 rounded-xl shadow hover:shadow-lg transition">
                    <p className="text-xs text-gray-500 font-bold uppercase">
                      Phone 02
                    </p>
                    <a
                      href="tel:+94717551836"
                      className="text-lg font-semibold hover:text-green-700"
                    >
                      +94 71 755 1836
                    </a>
                    <a
                      href="https://wa.me/94717551836"
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center gap-2 text-green-600 text-sm mt-1"
                    >
                      <FaWhatsapp className="text-lg" />
                      WhatsApp
                    </a>
                    <p className="text-sm text-gray-600 mt-1">
                      Customer Support
                    </p>
                  </div>

                  {/* Email */}
                  <div className="bg-white p-5 rounded-xl shadow hover:shadow-lg transition">
                    <p className="text-xs text-gray-500 font-bold uppercase">
                      Email
                    </p>
                    <p className="text-lg font-semibold">
                      chelinkoss@gmail.com
                    </p>
                  </div>

                  {/* Address */}
                  <div className="bg-white p-5 rounded-xl shadow hover:shadow-lg transition">
                    <p className="text-xs text-gray-500 font-bold uppercase">
                      Address
                    </p>
                    <p className="text-lg font-semibold">
                      103/A, Kottawa Rd, Athurugiriya
                    </p>
                  </div>

                  {/* Hours */}
                  <div className="bg-white p-5 rounded-xl shadow hover:shadow-lg transition md:col-span-2">
                    <p className="text-xs text-gray-500 font-bold uppercase">
                      Hours
                    </p>
                    <p className="text-lg font-semibold">
                      Mon - Fri: 8AM - 6PM
                    </p>
                    <p className="text-sm text-gray-600 mt-1">UTC +5:30</p>
                  </div>
                </div>
              </section>
            </AnimatedSection>

            {/* RIGHT → FORM */}
            <AnimatedSection delay={0.1}>
              <section className="bg-white p-8 sm:p-10 rounded-xl border border-gray-200 shadow-md hover:shadow-lg transition-all">
                <h3 className="text-gray-900 text-xl sm:text-2xl font-bold mb-6 sm:mb-8">
                  Send an Inquiry
                </h3>

                <form
                  onSubmit={handleSubmit}
                  className="flex flex-col gap-4 sm:gap-6"
                >
                  {/* Name & Company */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      required
                      value={form.name}
                      onChange={handleChange}
                      className="border border-gray-300 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-green-600 outline-none w-full"
                    />
                    <input
                      type="text"
                      name="company"
                      placeholder="Company Name"
                      value={form.company}
                      onChange={handleChange}
                      className="border border-gray-300 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-green-600 outline-none w-full"
                    />
                  </div>

                  {/* Subject */}
                  <select
                    name="subject"
                    value={form.subject}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-green-600 outline-none w-full"
                  >
                    <option>Request for Quote (RFQ)</option>
                    <option>Custom Fabrication Project</option>
                    <option>Technical Consultation</option>
                    <option>Other</option>
                  </select>

                  {/* Message */}
                  <textarea
                    name="message"
                    rows="5"
                    placeholder="Describe your project requirements..."
                    required
                    value={form.message}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-green-600 outline-none resize-none w-full"
                  />

                  {/* Submit */}
                  <button
                    type="submit"
                    className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-bold py-4 rounded-lg transition shadow-md flex items-center justify-center gap-2"
                  >
                    <FaWhatsapp className="text-2xl" /> Send via WhatsApp
                  </button>
                </form>
              </section>
            </AnimatedSection>
          </div>

          {/* FULL WIDTH MAP */}
          <AnimatedSection delay={0.2}>
            <div className="mt-12 sm:mt-16">
              <h2 className="text-2xl sm:text-3xl font-bold mb-4">
                Location & Service Area
              </h2>

              <div style={{ width: "100%", height: "400px" }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d247.5751107486919!2d79.99834195166721!3d6.866408141105156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25187130932a3%3A0x4791de29335d7b5d!2sChelinko!5e0!3m2!1sen!2slk!4v1778091692615!5m2!1sen!2slk"
                  title="Google Map Location"
                  style={{
                    width: "100%",
                    height: "100%",
                    border: 0,
                  }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </main>
    </div>
  );
};

export default ContactUs;
